import * as React from 'react';
import { IStringLocalizer } from '../../../utilities/IStringLocalizer';
import { useLocalizer } from './hooks/useLocalizer';

interface AIProcessingWarningProps {
    localizer?: IStringLocalizer;
}

/**
 * Warning message displayed before AI file processing
 * Informs users about survey locking and processing duration
 */
export const AIProcessingWarning: React.FC<AIProcessingWarningProps> = ({ localizer }) => {
    const localize = useLocalizer(localizer);

    return (
        <div className="alert alert-warning" style={{ marginTop: '15px' }}>
            <div>
                <strong>{localize("Processing files will lock the survey.")}</strong>
            </div>
            <div>
                {localize("Depending on survey and file sizes this may take between a few minutes and a few hours. You can navigate away during this time - processing will continue in the background.")}
            </div>
        </div>
    );
};

export default AIProcessingWarning;
